var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8252 0C4.40645 0 0.825195 3.58125 0.825195 8C0.825195 12.4187 4.40645 16 8.8252 16C13.2439 16 16.8252 12.4187 16.8252 8C16.8252 3.58125 13.2439 0 8.8252 0ZM8.8252 4C9.37738 4 9.8252 4.44781 9.8252 5C9.8252 5.55219 9.37738 6 8.8252 6C8.27301 6 7.8252 5.55312 7.8252 5C7.8252 4.44688 8.27207 4 8.8252 4ZM10.0752 12H7.5752C7.1627 12 6.8252 11.6656 6.8252 11.25C6.8252 10.8344 7.16113 10.5 7.5752 10.5H8.0752V8.5H7.8252C7.41113 8.5 7.0752 8.16406 7.0752 7.75C7.0752 7.33594 7.4127 7 7.8252 7H8.8252C9.23926 7 9.5752 7.33594 9.5752 7.75V10.5H10.0752C10.4893 10.5 10.8252 10.8359 10.8252 11.25C10.8252 11.6641 10.4908 12 10.0752 12Z",
    fill: "#878FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d83e09d73991b8e93198f00b52c8409b.svg";
export { ForwardRef as ReactComponent };